import Spinner from '~/components/Spinner'
import { ChestSize } from '~/components/Chest/types'
import { getLoaderSize } from '~/components/Chest/helpers'

export default function ChestLoader({
  containerHeight,
  containerWidth,
  displayLoader,
  size,
}: {
  containerHeight: number
  containerWidth: number
  displayLoader: boolean
  size: ChestSize
}): React.ReactElement {
  const style = {
    width: containerWidth,
    height: containerHeight,
  }

  return (
    <div className={`flex items-center justify-center ${displayLoader ? 'block' : 'hidden'}`} style={style}>
      <Spinner size={getLoaderSize(size)} />
    </div>
  )
}
